import { useQuery } from "react-query";

import { searchService } from "services";

type UseUserSearchQueryProps = {
	pattern: string;
	page: number;
	options?: any;
};

const useUserSearchQuery = ({
	pattern,
	page,
	options,
}: UseUserSearchQueryProps) =>
	useQuery(
		["userSearch", pattern, page],
		() =>
			searchService.getUsers({
				pattern,
				page,
			}),
		{
			...options,
		},
	);

export default useUserSearchQuery;
